<template>
    <div class="col-md-12 px-0 py-0">
        <div class="form-group row">
            <div class="col-md-9">
                <div class="form-row align mt-3">
                    <div class="form-group col-md-3">
                        <select class="form-control" v-model="criterio">
                            <option value="name">Nombre</option>
                            <option value="status">Estado</option>
                            <option value="country">Pais</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4">
                        <input
                            type="text"
                            v-model="search"
                            @keyup.enter="getListModel()"
                            class="form-control"
                            placeholder="Texto a buscar"
                        />
                    </div>
                    <button
                        type="button"
                        @click="getListModel()"
                        class="btn btn-primary mb-3"
                    >
                        <em class="fa fa-search"></em> Buscar
                    </button>
                </div>
            </div>
        </div>
        <table class="table table-bordered table-striped table-sm mt-3">
            <thead>
                <tr>
                    <th>Opciones</th>
                    <th>ID</th>
                    <th>Nombre</th>
                    <th>Versión</th>
                    <th>Estado</th>
                    <th>Categorias</th>
                    <th>Imagen</th>
                    <th>Fecha Creación</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="model in arrayModel" :key="model.id">
                    <td>
                        <button
                            v-tooltip.bottom-start="'Editar'"
                            type="button"
                            @click="changeView(2, model.id, model.name)"
                            class="btn btn-warning btn-sm"
                        >
                            <em class="fa fa-edit"></em>
                        </button>
                    </td>
                    <td v-text="model.id"></td>
                    <td v-text="model.name"></td>
                    <td v-text="model.version"></td>
                    <td v-text="model.status"></td>
                    <td>
                        <span
                            v-for="category in model.categories"
                            :key="category.name"
                            v-text="category.name"
                            class="badge badge-success mr-1"
                        ></span>
                    </td>
                    <td>
                        <img
                            :src="model.image"
                            style="max-width: 100px"
                            alt="image"
                        />
                    </td>
                    <td v-text="model.created_at"></td>
                </tr>
            </tbody>
        </table>
        <nav>
            <ul class="pagination">
                <li class="page-item" v-if="pagination.current_page > 1">
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page - 1)"
                        >Ant</a
                    >
                </li>
                <li
                    class="page-item"
                    v-for="page in pagesNumber"
                    :key="page"
                    :class="[page == isActived ? 'active' : '']"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(page)"
                        v-text="page"
                    ></a>
                </li>
                <li
                    class="page-item"
                    v-if="pagination.current_page < pagination.last_page"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page + 1)"
                        >Sig</a
                    >
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: "ContestListComponent",
    data() {
        return {
            arrayModel: [],
            pagination: {
                total: 0,
                current_page: 0,
                per_page: 0,
                last_page: 0,
                from: 0,
                to: 0,
            },
            offset: 15,
            criterio: "name",
            search: "",
        };
    },
    computed: {
        isActived: function () {
            return this.pagination.current_page;
        },
        pagesNumber: function () {
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset * 2;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },
    },
    methods: {
        changePage(page) {
            let me = this;
            me.pagination.current_page = page;
            me.getListModel(page);
        },
        getListModel(page = 1) {
            let me = this;
            let criterio = me.criterio;
            let search = me.search;
            axios
                .get(
                    "/api/contests?page=" +
                        page +
                        "&criterio=" +
                        criterio +
                        "&search=" +
                        search
                )
                .then(function (response) {
                    me.arrayModel = response.data.models.data;
                    me.pagination = response.data.pagination;
                })
                .catch(function (error) {});
        },
        changeView(page, id, name) {
            this.$emit("change", { page: page, id: id, name: name });
        },
    },
    mounted() {
        this.getListModel();
    },
};
</script>

<style scoped>
.form-control {
    border-radius: 0.2rem !important;
    height: 37px;
}

select.form-control:not([size]):not([multiple]) {
    height: 37px;
}

.btn {
    height: 37px !important;
}

.align {
    display: flex;
    align-items: center;
}
</style>
